import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "txt-center": "",
  class: "dialog-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": _ctx.isOpen,
    title: "Invite Talent",
    width: "500px",
    "before-close": _ctx.handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _ctx.sendInvitation,
          loading: _ctx.loading,
          disabled: _ctx.loading,
          icon: "el-icon-position",
          size: "large",
          type: "primary"
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode(" Send Invitation ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick", "loading", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_el_form, {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
          class: "App-Styled-Form",
          "label-position": 'top',
          "label-width": "100px",
          model: _ctx.form,
          style: {"margin-top":"12px"}
        }, {
          default: _withCtx(() => [
            _cache[3] || (_cache[3] = _createElementVNode("p", { "txt-center": "" }, [
              _createTextVNode(" Type the email of the "),
              _createElementVNode("br"),
              _createTextVNode(" person to send an invitation to. ")
            ], -1)),
            _createVNode(_component_el_form_item, {
              prop: "email",
              label: "Email"
            }, {
              label: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Message)
                  ]),
                  _: 1
                }),
                _cache[2] || (_cache[2] = _createTextVNode(" Email ", -1))
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: "johndoe@e4t.com",
                  modelValue: _ctx.form.email,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["model-value", "before-close"]))
}